export default "__VITE_ASSET__BqXp2WEe__"